import { useContext, useState, useEffect } from "react";
import { UserSettingsContext } from "./components/UserSettingsProvider.js";
function useUserStorage() {
  const { storage } = useContext(UserSettingsContext);
  return storage;
}
function useUserSettings(props) {
  const { userId, featureName, settingName } = props;
  const userSettingsStorage = useUserStorage();
  const [settingsId, setSettingsId] = useState(null);
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    if (userId && featureName && settingName) {
      userSettingsStorage.userSettings.get({
        userId,
        featureName,
        settingName
      }).then((value) => {
        if (value) {
          setSettings(value);
          setSettingsId(value.id);
        }
      });
    }
  }, [userId, featureName, settingName]);
  function handleSettingsChange(value) {
    function updateState() {
      setSettings({ ...settings, value });
    }
    if (settingsId) {
      userSettingsStorage.userSettings.update(settingsId, { value }).then(updateState);
    } else {
      userSettingsStorage.userSettings.add({ userId, featureName, settingName, value }).then((id) => {
        updateState();
        setSettingsId(id);
      });
    }
  }
  return {
    settings,
    onSettingsChange: handleSettingsChange
  };
}
function useColumnsSettings({ pinnedColumns, defaultColumns, settingId, ...props }, _useUserSettings = useUserSettings) {
  const { settings, onSettingsChange } = _useUserSettings({
    ...props,
    featureName: settingId,
    settingName: "visible_columns"
  });
  const storedColumns = settings?.value ? settings.value : defaultColumns;
  const pinned = pinnedColumns ?? [];
  return {
    pinned,
    visible: [.../* @__PURE__ */ new Set([...pinned, ...storedColumns])],
    onVisibleColumnsChange: onSettingsChange
  };
}
export {
  useColumnsSettings,
  useUserSettings,
  useUserStorage
};
//# sourceMappingURL=hooks.js.map
